import React, {useEffect, useState} from "react";
import {Checkbox as AntdCheckbox} from "antd";

const placements = {
    START: 'start',
    END: 'end'
}

const Checkbox = props => {
    const {label = '', onChangeCallback, onChange, labelPlacement = placements.END, required, children, checked = false, value = 'on', ...other} = props;

    const [isChecked, setIsChecked] = useState(false);

    useEffect(()=>{
        setIsChecked(checked);
    },[checked]);

    const handleChange = (e) => {
        if(onChangeCallback && typeof onChangeCallback === 'function'){
            onChangeCallback(e);
        }
        setIsChecked(!isChecked);
    };
    // pass in onchange event if specified else use handleChange Event
    return (
        // <label className='ch-checkbox-wrapper ch-check-radio-wrapper'>
            <AntdCheckbox checked={isChecked} onChange={onChange ? onChange : handleChange} {...other} value={value}>
                {label}
            </AntdCheckbox>
        // </label>
    )
}

export default Checkbox;